export default __webpack_public_path__ + "static/media/project-bg-smd.48af2354.svg";